import 'mobx-wrap-request';
import './styles/reset.css';
import './styles/main.scss';

import classnames from 'classnames';
import { configure as mobxConfigure } from 'mobx';
import * as React from 'react';
// eslint-disable-next-line react/no-deprecated
import { render } from 'react-dom';
// @ts-ignore
import smoothscroll from 'smoothscroll-polyfill';
import { TSDI } from 'tsdi';

import { App } from './app';
import { ErrorHandler } from './components/error-handler';
import { BugsnagErrorBoundary } from './core/bugsnag';
import { DateTimeStore } from './core/datetime-store';
import { TsdiLifeCycle } from './core/reactions';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).classnames = classnames;

smoothscroll.polyfill();

mobxConfigure({
    enforceActions: 'never'
});

const tsdi = new TSDI();
tsdi.enableComponentScanner();
tsdi.get(TsdiLifeCycle);
tsdi.get(DateTimeStore);

const browserLanguage = window.navigator.language.split('-')[0];
document.title = 'Studio';
document
    .querySelector('html')
    ?.setAttribute('data-user-language', browserLanguage);

render(
    <BugsnagErrorBoundary FallbackComponent={ErrorHandler}>
        <App />
    </BugsnagErrorBoundary>,
    document.getElementById('app')
);
